import PropTypes from 'prop-types';

export default function StaticResponsiveHeaderBanner({ htmlContent, isBrowserRendering, isMobile }) {

  let parsedHtmlContent = null;

  // switching between small image for mobiles and big image for tablet/desktop
  // It's implemented in such a complicated way because of old CMS system in Site management
  // which returns banners in pure HTML format an requires changes in JS on the client side
  if (htmlContent.includes('data-big="') && !isBrowserRendering) {
    parsedHtmlContent = htmlContent.replace('src="', 'data-small="').replace('data-big="', 'src="');
  } else if (htmlContent.includes('data-small="') && isMobile) {
    parsedHtmlContent = htmlContent.replace('src="', 'data-big="').replace('data-small="', 'src="');
  } else if (htmlContent.includes('data-big="') && !isMobile) {
    parsedHtmlContent = htmlContent.replace('src="', 'data-small="').replace('data-big="', 'src="');

  }

  if (!parsedHtmlContent) {
    parsedHtmlContent = htmlContent;
  }

  return (
    <div
  // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: parsedHtmlContent }}
      style={{ paddingBottom: '10px' }}
    />
  );

}

StaticResponsiveHeaderBanner.displayName = 'StaticResponsiveHeaderBanner';

StaticResponsiveHeaderBanner.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isBrowserRendering: PropTypes.bool.isRequired,
  htmlContent: PropTypes.string.isRequired
};
